/**
 * Status pill. Colour is never the only carrier of meaning: every state also
 * has a distinct glyph and a word, so it survives colour blindness and a
 * black-and-white printout.
 */
export type Status = 'ok' | 'warn' | 'stale' | 'missing' | 'failed' | 'unknown';

const LABELS: Record<Status, { text: string; glyph: string }> = {
  ok:      { text: 'в норме',      glyph: '●' },
  warn:    { text: 'внимание',     glyph: '▲' },
  stale:   { text: 'устарел',      glyph: '▲' },
  missing: { text: 'нет копий',    glyph: '■' },
  failed:  { text: 'сбой',         glyph: '✕' },
  unknown: { text: 'нет данных',   glyph: '?' },
};

export function StatusBadge({ status }: { status: Status }): React.JSX.Element {
  const { text, glyph } = LABELS[status];
  return (
    <span className={`badge badge--${status}`}>
      <span className="badge__glyph" aria-hidden="true">{glyph}</span>
      {text}
    </span>
  );
}
